import PropTypes from "prop-types";
import React from "react";
import { DropdownItem, Input, Label } from "reactstrap";

const CustomToggleList = props => {
  const { columns, onColumnToggle, toggles, optionShowColumnHandel } = props;

  return (
    <React.Fragment>
      {columns &&
        columns
          .map(column => ({
            ...column,
            toggle: toggles[column.dataField],
          }))
          .map(column => {
            return (
              column.dataField !== "dfExpand" &&
              column.dataField !== "rowIndex" &&
              column.dataField !== "action" && (
                <DropdownItem toggle={false} key={column.dataField}>
                  <Label style={{ width: "100%", cursor: "pointer" }}>
                    <Input
                      type="checkbox"
                      className="me-2"
                      defaultChecked={column.toggle}
                      onClick={e => {
                        //
                        let columnsVisible = {};
                        for (const item of columns) {
                          columnsVisible[item.dataField] = !item.hidden;
                        }
                        columnsVisible = {
                          ...columnsVisible,
                          [column.dataField]: !column.toggle,
                        };
                        //
                        if (optionShowColumnHandel) {
                          optionShowColumnHandel(
                            column.dataField,
                            !column.toggle,
                            columnsVisible
                          );
                        }
                        onColumnToggle(column.dataField);
                      }}
                    />
                    {column.text}
                  </Label>
                </DropdownItem>
              )
            );
          })}
    </React.Fragment>
  );
};

CustomToggleList.propTypes = {
  onColumnToggle: PropTypes.func,
  toggles: PropTypes.any,
  columns: PropTypes.array,
  optionShowColumnHandel: PropTypes.func,
};
export default CustomToggleList;
